import { render, staticRenderFns } from "./erVisits.vue?vue&type=template&id=219046bc"
import script from "./erVisits.vue?vue&type=script&lang=js"
export * from "./erVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports